/**
 * @desc 开放平台快捷登录
 */
import { LoginResult, LoginMiniCodeForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type LoginMemberByOpenCodeParameter = LoginMiniCodeForm

const method = 'GET'
const url = '/auth/member/login/openCode'

export const loginMemberByOpenCodeApi = (
  params?: LoginMemberByOpenCodeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LoginResult>({
    method,
    url,
    params,
    ...config
  })
}

loginMemberByOpenCodeApi.method = method
loginMemberByOpenCodeApi.url = url
